.item {
  display: inline-block;
  margin-bottom: 0.5rem;
  margin-right: 2rem;
  margin-top: 0.5rem;
  width: 40%;
}
